import AppLayout from '../layout/AppLayout';
import Loader from '../loader/loader';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import regenerateToken from '../regenerateToken';
import sampleJson from './sampleJson';
import { useAlert } from 'react-alert';
import { Spinner } from 'react-bootstrap';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import { FaFilePdf, FaCloudUploadAlt, FaRulerVertical, FaCode, FaHeading, FaLevelDownAlt } from 'react-icons/fa';
import './sampleGenerator.css';

const SampleGenerator = () => {
  const [pageLoader, setPageLoader] = useState(true);
  const [headerImage, setHeaderImage] = useState('');
  const [footerImage, setFooterImage] = useState('');
  // const [headerPrefix, setHeaderPrefix] = useState('');
  // const [footerPrefix, setFooterPrefix] = useState('');
  const [headerMargin, setHeaderMargin] = useState('120px');
  const [footerMargin, setFooterMargin] = useState('82px');
  const [downloadingLoader, setDownloadingLoader] = useState(false);
  const [jsonEditor, setJsonEditor] = useState(false);
  const [testJson, setTestJson] = useState(sampleJson);

  const alert = useAlert();

  useEffect(() => {
    setTimeout(() => {
      setPageLoader(false);
    }, 1000);
  }, []);

  const convertFileToBase64 = file => {
    if (file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.onerror = error => {
          reject(error);
        };
      });
    } else {
      return '';
    }
  };

  const generatingSampleReport = async event => {
    event.preventDefault();
    const sampleJsonDeepCopy = JSON.parse(JSON.stringify(testJson));
    const headerBase64 = await convertFileToBase64(headerImage);
    const footerBase64 = await convertFileToBase64(footerImage);
    if (headerBase64 && headerBase64.includes(',')) {
      sampleJsonDeepCopy.headerBase64 = headerBase64.split(',')[1];
      sampleJsonDeepCopy.headerPrefix = headerBase64.split(',')[0] + ',';
    } else {
      sampleJsonDeepCopy.headerBase64 = '';
      sampleJsonDeepCopy.headerPrefix = '';
    }
    if (footerBase64 && footerBase64.includes(',')) {
      sampleJsonDeepCopy.footerBase64 = footerBase64.split(',')[1];
      sampleJsonDeepCopy.footerPrefix = footerBase64.split(',')[0] + ',';
    } else {
      sampleJsonDeepCopy.footerBase64 = '';
      sampleJsonDeepCopy.footerPrefix = '';
    }
    try {
      setDownloadingLoader(true);
      const sampleReportAPI =
        'https://917sfoy1xc.execute-api.ap-south-1.amazonaws.com/production/sample-generator';
      const idToken = Cookies.get('idToken');
      if (!idToken) {
        alert.error('Session expired. Please log in again.');
        setDownloadingLoader(false);
        return;
      }
      let configurationBody = {
        url: sampleReportAPI,
        method: 'POST',
        headers: {
          authorization: idToken,
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(sampleJsonDeepCopy),
        validateStatus: function (status) {
          return status >= 200 && status <= 401;
        },
      };
      let sampleReportResponse = await axios(configurationBody);
      if (sampleReportResponse.status === 401) {
        await regenerateToken();
        const freshToken = Cookies.get('idToken');
        if (!freshToken) {
          alert.error('Session expired. Please log in again.');
          setDownloadingLoader(false);
          return;
        }
        configurationBody = {
          ...configurationBody,
          headers: { authorization: freshToken, 'Content-Type': 'application/json' },
        };
        sampleReportResponse = await axios(configurationBody);
      }
      if (sampleReportResponse.status === 200) {
        downloadPDF(sampleReportResponse.data.PdfData);
        alert.show('Sample Smart Report successfully downloaded');
      } else if (sampleReportResponse.status === 401) {
        alert.error('Unauthorized. Please log in again.');
      } else {
        alert.error(sampleReportResponse?.data?.message || 'Failed to generate sample report.');
      }
    } catch (e) {
      alert.error(e.response?.data?.message || e.message);
    } finally {
      setDownloadingLoader(false);
    }
  };

  const downloadPDF = (myPdfDoc, emp_name = 'Sample Report') => {
    console.log('the file getting downloaded');
    const linkSource = `data:application/pdf;base64,${myPdfDoc}`;
    const downloadLink = document.createElement('a');
    const fileName = `${emp_name}.pdf`;

    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };
  return (
    <AppLayout>
      {pageLoader ? (
        <Loader />
      ) : (
        <div className='sg-container'>
          <form onSubmit={e => generatingSampleReport(e)}>

            {/* Header */}
            <header className="sg-header">
              <div className="sg-title-group">
                <h1 className="sg-title">Report Generator</h1>
                <p className="sg-subtitle">Generate and preview sample reports with custom headers and data.</p>
              </div>
              <div className="sg-actions-top">
                <button
                  type="submit"
                  className="sg-btn-primary"
                  disabled={downloadingLoader}
                >
                  {downloadingLoader ? (
                    <Spinner animation='border' role='status' size='sm' />
                  ) : (
                    <>
                      <FaFilePdf size={18} /> Generate Sample Report
                    </>
                  )}
                </button>
              </div>
            </header>

            <div className="sg-bento-grid">

              {/* Header Configuration Card */}
              <div className="sg-card">
                <div className="sg-card-header">
                  <span className="d-flex align-items-center gap-2">
                    <FaHeading style={{ color: '#3b82f6' }} />
                    <h3 className="sg-card-title">Header Configuration</h3>
                  </span>
                </div>
                <div className="sg-card-body">
                  {/* Image Upload */}
                  <div className="sg-input-group">
                    <label className="sg-label">Header Image</label>
                    <div className="sg-upload-zone">
                      <input
                        type="file"
                        className="sg-file-input"
                        accept='image/png,image/jpeg,image/svg+xml'
                        onChange={event => setHeaderImage(event.target.files[0])}
                      />
                      <div className="sg-upload-icon"><FaCloudUploadAlt /></div>
                      <div className="sg-upload-text">
                        {headerImage ? 'Change File' : 'Click to Upload Header Image'}
                      </div>
                      {headerImage && <div className="sg-file-name">{headerImage.name}</div>}
                    </div>
                  </div>

                  {/* Header Margin */}
                  <div className="sg-input-group">
                    <label className="sg-label">Header Height (px)</label>
                    <div style={{ position: 'relative' }}>
                      <FaRulerVertical style={{ position: 'absolute', top: '12px', left: '12px', color: '#94a3b8' }} />
                      <input
                        className="sg-input"
                        style={{ paddingLeft: '32px' }}
                        type='number'
                        placeholder='120'
                        value={headerMargin.replace('px', '')}
                        onChange={event => setHeaderMargin(event.target.value + 'px')}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Footer Configuration Card */}
              <div className="sg-card">
                <div className="sg-card-header">
                  <span className="d-flex align-items-center gap-2">
                    <FaLevelDownAlt style={{ color: '#6366f1' }} />
                    <h3 className="sg-card-title">Footer Configuration</h3>
                  </span>
                </div>
                <div className="sg-card-body">
                  {/* Image Upload */}
                  <div className="sg-input-group">
                    <label className="sg-label">Footer Image</label>
                    <div className="sg-upload-zone">
                      <input
                        type="file"
                        className="sg-file-input"
                        accept='image/png,image/jpeg,image/svg+xml'
                        onChange={event => setFooterImage(event.target.files[0])}
                      />
                      <div className="sg-upload-icon"><FaCloudUploadAlt /></div>
                      <div className="sg-upload-text">
                        {footerImage ? 'Change File' : 'Click to Upload Footer Image'}
                      </div>
                      {footerImage && <div className="sg-file-name">{footerImage.name}</div>}
                    </div>
                  </div>

                  {/* Footer Margin */}
                  <div className="sg-input-group">
                    <label className="sg-label">Footer Height (px)</label>
                    <div style={{ position: 'relative' }}>
                      <FaRulerVertical style={{ position: 'absolute', top: '12px', left: '12px', color: '#94a3b8' }} />
                      <input
                        className="sg-input"
                        style={{ paddingLeft: '32px' }}
                        type='number'
                        placeholder='82'
                        value={footerMargin.replace('px', '')}
                        onChange={event => setFooterMargin(event.target.value + 'px')}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Report Data Configuration */}
              <div className="sg-card sg-card-wide">
                <div className="sg-card-header">
                  <span className="d-flex align-items-center gap-2">
                    <FaCode style={{ color: '#f59e0b' }} />
                    <h3 className="sg-card-title">Report Data JSON</h3>
                  </span>
                  <div className="sg-switch-wrapper" onClick={() => setJsonEditor(!jsonEditor)}>
                    <span className="sg-switch-label">
                      {jsonEditor ? 'Close Editor' : 'Edit JSON Data'}
                    </span>
                    <div className={`sg-switch ${jsonEditor ? 'active' : ''}`}></div>
                  </div>
                </div>
                {jsonEditor && (
                  <div className="sg-card-body" style={{ padding: '0' }}>
                    <JSONInput
                      id='a_unique_id'
                      placeholder={testJson}
                      locale={locale}
                      onChange={e => e.jsObject !== undefined && setTestJson(e.jsObject)}
                      colors={{
                        string: '#3b82f6',
                        background: '#1e293b',
                        keys: '#94a3b8'
                      }}
                      height='400px'
                      width='100%'
                      style={{ body: { fontSize: '13px' } }}
                    />
                  </div>
                )}
                {!jsonEditor && (
                  <div className="sg-card-body" style={{ textAlign: 'center', color: '#94a3b8', padding: '3rem' }}>
                    <p>JSON Editor is closed. Enable the switch above to customize the report data.</p>
                  </div>
                )}
              </div>

            </div>
          </form>
        </div>
      )}
    </AppLayout>
  );
};
export default SampleGenerator;
